import React from 'react';
import {
  SearchableVendorTaxonomyKey,
  SEARCHABLE_VENDOR_TAXONOMY_KEYS,
} from '@zola-helpers/client/dist/es/marketplace/vendorTaxonomyKeys';
import { getVendorWordPill } from '@zola-helpers/client/dist/es/marketplace/vendorWords';
import { LinkV2 } from '../LinkV2';
import VendorIcon from '../VendorIcon/VendorIcon';
import { CategoryList, VendorName } from './VendorsCategoryList.styles';

export type VendorsCategoryListProps = React.HTMLAttributes<HTMLUListElement> & {
  categories?: SearchableVendorTaxonomyKey[];
  openInNewTab?: boolean;
  onLinkClick?: () => void | null;
};

export const VendorsCategoryList = ({
  categories = SEARCHABLE_VENDOR_TAXONOMY_KEYS,
  className,
  openInNewTab = false,
  onLinkClick = () => null,
}: VendorsCategoryListProps): JSX.Element => {
  const linkProps = openInNewTab
    ? {
        target: '_blank',
      }
    : {};
  return (
    <CategoryList className={className} data-testid="category-links">
      {categories.map((vendorTaxonomyKey) => {
        const url = `/wedding-vendors/${vendorTaxonomyKey}`;
        const name = getVendorWordPill(vendorTaxonomyKey);
        return (
          <li key={`explore-by-category-${vendorTaxonomyKey}`}>
            <LinkV2
              href={url}
              noUnderline
              data-testid="category-link"
              onClick={onLinkClick}
              {...linkProps}
            >
              <VendorIcon vendorTaxonomyKey={vendorTaxonomyKey} iconWidth={32} />
              <VendorName data-testid="category-name">{name}</VendorName>
            </LinkV2>
          </li>
        );
      })}
    </CategoryList>
  );
};

export default VendorsCategoryList;
